var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.id)?_c('v-btn',{staticClass:"grey lighten-3 black--text",attrs:{"icon":""},on:{"click":_vm.handleProfile}},[_c('MyIcon',{attrs:{"name":"mdi:clipboard-account"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }